export class IMemberEmergencyContact {
    _id: string;
    name: string;
    realtioship: string;
    email: string;
    contact: string;
    contactHome: string;
    contactWork: string;
    medicalDetail: string;
    age: string;
}